import React, { useEffect, useState, useRef } from "react";
import EmojiPicker from "emoji-picker-react";
import ChatSidebar from "./ChatSidebar";
// import io, { Socket } from "socket.io-client";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { socket } from "../apis/api/Config";
// const socket = io("https://clubnet.app", { path: "/dev_node/connection" });

const ChatApp = () => {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [message, setMessage] = useState("");
  const [chatlist, setchatlist] = useState([]);
  const [receiver, setReceiver] = useState([]);
  const [history, sethistory] = useState({});
  const emojiPickerRef = useRef(null);

  const messagesEndRef = useRef(null); // Create a reference for the chat container

  let memberData = useSelector((state) => state.profileSlice.profile);
  let { profile } = useSelector((state) => state.dashboardSlice);
  let allprofile = profile?.data || [];

  const senderUserId = Cookies.get("userId");
  const receiverUserId = receiver.member_id;

  const handleEmojiClick = (emojiObject) => {
    setMessage((prevMessage) => prevMessage + emojiObject.emoji);
  };

  const handlesubmit = async () => {
    const date = new Date().toLocaleDateString("en-GB").replace(/\//g, "");
    if (message.trim()) {
      const timestrap = Math.floor(Date.now() / 1000);
      const data = {
        senderUserId,
        receiverUserId,
        message,
        timestrap,
        date,
      };

      socket.emit("sendPrivateMessage", data);

      if (history[date]) {
        sethistory((prevHistory) => ({
          ...prevHistory,
          [date]: [...prevHistory[date], data],
        }));
      } else {
        sethistory((prevHistory) => ({
          ...prevHistory,
          [date]: [data],
        }));
      }
      setMessage("");
    }
  };
  useEffect(() => {
   
    const handleClickOutside = (event) => {
      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
        setShowEmojiPicker(false); 
      }
    };

   
    document.addEventListener("mousedown", handleClickOutside);

    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    // socket.emit("registerUser", senderUserId);

    const data = {
      senderUserId,
      receiverUserId,
    };
    socket.emit("getMessages", data);

    const listdata = {
      senderUserId,
    };

    socket.emit("getlist", listdata);

    const readmsz = {
      senderUserId,
      receiverUserId,
    };
    socket.emit("readmsz", readmsz);

    socket.on("chatlist", (data) => {
      setchatlist(data);
    });

    socket.on("chatHistory", (history) => {
      sethistory(history);
    });

    socket.on("receivePrivateMessage", (data) => {
      const date = data.date;

      if (data.senderUserId == receiverUserId) {
        sethistory((prevHistory) => {
          return {
            ...prevHistory,
            [date]: [...(prevHistory[date] || []), data],
          };
        });
      } else {
        let updatedChatlist = chatlist.reduce((result, member) => {
          if (member.member_id == data.senderUserId) {
            result.unshift({ ...member, unread_count: 1 });
          } else {
            result.push(member);
          }
          return result;
        }, []);

        let isUserInChatlist = updatedChatlist.find(
          (member) => member.member_id == data.senderUserId
        );

        if (!isUserInChatlist) {
          let newMember = allprofile?.find(
            (item) => item.member_id == data.senderUserId
          );

          if (newMember) {
            chatlist.unshift({
              member_id: newMember.member_id,
              member_name: newMember.member_name,
              member_logo: newMember.member_logo,
              company_name: newMember.company_name,
              unread_count: 1,
            });
          }
          setchatlist(chatlist);
        } else {
          setchatlist(updatedChatlist);
        }
      }
    });
    socket.on("disconnect", () => {
      console.log("Disconnected from server");
      // Handle any UI changes or cleanup when disconnected
    });
    return () => {
      socket.off("receivePrivateMessage");
    };
  }, [receiver, allprofile]);

  const handleMemberSelect = (selectedMember) => {
    setReceiver(selectedMember);
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return `${date.getHours()}:${date.getMinutes() < 10 ? "0" : ""
      }${date.getMinutes()} ${date.getHours() >= 12 ? "PM" : "AM"}`;
  };

  const convertDateFormat = (dateStr) => {
    const day = dateStr.substring(0, 2);
    const month = dateStr.substring(2, 4);
    const year = "20" + dateStr.substring(4, 6);

    const formattedDate = new Date(`${year}-${month}-${day}`);
    const today = new Date();

    // Extract day, month, and year from today's date
    const todayDay = String(today.getDate()).padStart(2, "0");
    const todayMonth = String(today.getMonth() + 1).padStart(2, "0");
    const todayYear = String(today.getFullYear()).slice(-2);

    const todayFormatted = `${todayDay}/${todayMonth}/${todayYear}`;

    if (`${day}/${month}/${year}` === todayFormatted) {
      return "Today";
    } else {
      return `${day}/${month}/${year}`;
    }
  };

  // Scroll to bottom whenever the history changes
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }
  }, [history]);

  return (
    <div className="container-fluid ">
      <div className="chat-app-container mt-3">
        <ChatSidebar
          new_message={"fg"}
          chatlist={chatlist}
          onSelectMember={handleMemberSelect}
        />

        <div className="chat-section border border-grey">
          <div className="header-chat d-flex align-items-center p-3 bg-light">
            <div
              className="photo"
              style={{
                backgroundImage: `url(${receiver.member_logo || "/dumy.jpeg"})`,
              }}
              onError={(e) => {
                e.target.src = "/dumy.jpeg";
              }}
            >
              <div className="online"></div>
            </div>

            <p className="name m-0 ml-2">{receiver.member_name}</p>

            <i
              className="icon clickable fa fa-ellipsis-h ml-auto"
              aria-hidden="true"
            ></i>
          </div>

          <div className="messages-chat" ref={messagesEndRef}>
            {Object.keys(history).map((date, index) => (
              <div key={index}>
                <div className="date-container">
                  <hr className="date-hr" />
                  <span className="date-text">{convertDateFormat(date)}</span>
                </div>

                {history[date]?.map((msg, idx) => (
                  <div key={idx}>
                    {msg.senderUserId == senderUserId ? (
                      <div className="message d-flex justify-content-end mb-3">
                        <div>
                          <p className="text wave-effect text-white p-2 rounded mb-1">
                            {msg.message}
                          </p>
                          <small className="text-muted text-end d-block">
                            {formatTime(msg.timestrap)}
                          </small>
                        </div>
                        <div
                          className="photo ml-2"
                          style={{
                            backgroundImage: `url(${memberData?.data?.members[0]?.member_logo ||
                              "/dumy.jpeg"
                              })`,
                          }}
                          onError={(e) => {
                            e.target.src = "/dumy.jpeg";
                          }}
                        ></div>
                      </div>
                    ) : msg.senderUserId == receiverUserId ? (
                      <div className="message">
                        <div
                          className="photo"
                          style={{
                            backgroundImage: `url(${receiver.member_logo || "/dumy.jpeg"
                              })`,
                          }}
                          onError={(e) => {
                            e.target.src = "/dumy.jpeg";
                          }}
                        >
                          <div className="online"></div>
                        </div>
                        <div>
                          <p className="text">{msg.message}</p>
                          <small className="text-muted text-end d-block">
                            {formatTime(msg.timestrap)}
                          </small>
                        </div>
                      </div>
                    ) : null}
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div className="footer-chat position-relative">
            <i
              className="far fa-smile fs-5 me-2"
              style={{ cursor: "pointer" }}
              onClick={() => setShowEmojiPicker(!showEmojiPicker)}
            ></i>
            {showEmojiPicker && (
              <div
              ref={emojiPickerRef} 
                className="emoji-picker-container position-absolute"
                style={{
                  bottom: "50px",
                  left: "0",
                  zIndex: "1000",
                }}
              >
                <EmojiPicker onEmojiClick={handleEmojiClick} />
              </div>
            )}
            <input
              type="text"
              className="write-message w-50"
              placeholder="Type your message here"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <button
              className="btn btn-primary btn-sm ms-1"
              onClick={handlesubmit}
            >
              <i className="far fa-paper-plane"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatApp;
